import { authService } from "@/services/authService";
import React,{useEffect,useState} from "react";
import { toast } from '@/components/ui/sonner';
import { useNavigate } from 'react-router-dom';

export default function ResetPassword(props) {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [accessToken, setAccessToken] = useState('');
    const [refreshToken, setRefreshToken] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));

        const access_token = params.get('access_token');
        const refresh_token = params.get('refresh_token');
        setAccessToken(access_token);
        setRefreshToken(refresh_token);        
    }, []);

    const handleUpdate = async () => {
        if(!password || !confirmPassword){
            toast.error('\nאנא מלא את כל השדות\n', {duration: 4000,position: 'top-center',style: {direction: 'rtl',fontSize: '24px'}});
            return;
        }
        if(password !== confirmPassword){
            toast.error('\nהסיסמאות לא תואמות\n', {duration: 4000,position: 'top-center',style: {direction: 'rtl',fontSize: '24px'}});
            return;
        }
        const { error } = await authService.ResetPassword(
            password,
            accessToken,
            refreshToken
        );

        if (error && error.message) {
            toast.error('\n' + error.message + '\n', { duration: 4000, position: 'top-center', style: { direction: 'rtl', fontSize: '24px' } });
        } else {
            toast.success('\nהסיסמה עודכנה בהצלחה\n', { duration: 4000, position: 'top-center', style: { direction: 'rtl', fontSize: '24px' } });
            navigate('/login');
        }
    };
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="max-w-md w-full bg-white p-8 rounded-lg shadow-md">
                <h2 className="text-2xl font-bold mb-4">איפוס סיסמה</h2>
                <form className="space-y-4">
                    <div className="flex flex-col">
                        <label htmlFor="newPassword" className="text-sm font-medium text-gray-700">סיסמה חדשה</label>
                        <input type="password" onChange={(e) => setPassword(e.target.value)} id="newPassword" className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary" placeholder="הכנס סיסמה חדשה" />
                    </div>
                    <div className="flex flex-col">
                        <label htmlFor="confirmPassword" className="text-sm font-medium text-gray-700">אישור סיסמה</label>
                        <input type="password" onChange={(e) => setConfirmPassword(e.target.value)} id="confirmPassword" className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary" placeholder="אשר את הסיסמה החדשה" />
                    </div>
                    <button type="submit" onClick={handleUpdate} className="w-full bg-primary text-primary-foreground py-2 px-4 rounded-md hover:bg-primary/90 transition-colors">
                        עדכן סיסמה
                    </button>
                </form>
            </div>
        </div>
    );
}